<div class="modal-body">
  <div class="col-xs-12 col-sm-10 col-md-8 col-lg-6">
    <h1>{{ 'BAG.CONFLICT' | translate }}</h1>
    <div class="col-xs-8 col-xs-offset-2">
      @if (responseMessage) {
        <p>{{ responseMessage }}</p>
      }
      <p>{{ 'BAG.BAGUPDATED' | translate }}</p>
      <div class="buttons">
        <button class="btn btn-primary" (click)="onOk()">{{ 'COMMON.OK' | translate }}</button>
      </div>
    </div>
  </div>
</div>